// extracted by mini-css-extract-plugin
export var headerCell = "_4o-1";
export var loadingSpinnerContainer = "_4o-4";
export var rowWrapper = "_4o-3";
export var standaloneTable = "_4o-5";
export var table = "_4o-0";
export var white = "_4o-2";